module.exports = __webpack_public_path__ + "media/images/icons/email_share_dark-f46702ad399c3f96750d697f7ef29655.svg";